import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React from "react";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { useProfile } from "../../../context/ProfileContext";
import { ISinisterValues } from "../../../shared/services/api/sinister/SinisterService";
import { useCanOpenModal } from "../hooks/useCanOpenModal";

type SinisterRowPropsType = {
	row: ISinisterValues;
	goTo: any;
	// Duplicar/espelhar (item 7) — abre "Adicionar valores" pré-preenchido com este lançamento.
	onDuplicate?: (row: ISinisterValues) => void;
};

export function RowMenu({ row, goTo, onDuplicate }: SinisterRowPropsType) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const { canOpenModal } = useCanOpenModal();
	const { isSuperAdmin } = useProfile();
	const canDuplicate = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Add);

	return (
		<>
			<Menu id={`actions-${row.id}`} anchorEl={anchorEl} open={open} onClose={handleClose}>
				{onDuplicate && (
					<MenuItem
						disabled={!canDuplicate}
						onClick={() => {
							onDuplicate(row);
							handleClose();
						}}
					>
						<ListItemIcon>
							<ContentCopyIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText primary="Duplicar" />
					</MenuItem>
				)}
				{onDuplicate && <Divider />}
				{["aprovar", "rejeitar", "cancelar", "contestar"].map((action) => {
					const modalMap = {
						aprovar: "openModalAproved",
						rejeitar: "openModalRefused",
						cancelar: "openModalCancel",
						contestar: "openModalContested",
					} as const;

					const labelMap = {
						aprovar: "Aprovar",
						rejeitar: "Rejeitar",
						cancelar: "Cancelar",
						contestar: "Contestar",
					};

					const modalType = modalMap[action as keyof typeof modalMap];
					const { canOpen } = canOpenModal(modalType, row);

					return (
						<MenuItem
							key={action}
							disabled={!canOpen}
							onClick={(e) => {
								goTo(action, row.id, e, row);
								handleClose();
							}}
						>
							{labelMap[action as keyof typeof labelMap]}
						</MenuItem>
					);
				})}
			</Menu>

			<IconButton size="small" onClick={handleClick} aria-label="Ações">
				<MoreVertIcon fontSize="small" />
			</IconButton>
		</>
	);
}
